import { render, staticRenderFns } from "./AnswerTip.vue?vue&type=template&id=d9f666ea&scoped=true&"
import script from "./AnswerTip.vue?vue&type=script&lang=js&"
export * from "./AnswerTip.vue?vue&type=script&lang=js&"
import style0 from "./AnswerTip.vue?vue&type=style&index=0&id=d9f666ea&prod&lang=scss&scoped=true&"
import style1 from "./AnswerTip.vue?vue&type=style&index=1&id=d9f666ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f666ea",
  null
  
)

export default component.exports